<template>
  <div
    v-if="shouldShow"
    class="OperatorRequestQRButtonBadge"
  >
    <el-tooltip
      :content="tooltipText"
      placement="top"
    >
      <component
        :is="iconComponent"
        class="w-full"
      />
    </el-tooltip>
  </div>
</template>

<script setup>
const props = defineProps({
  request: {
    type: Object,
    required: true,
  },
});

// Computed
const shouldShow = computed(() =>
  props.request?.is_from_qr === true ||
  (props.request?.organization && props.request?.client?.is_temp && !props.request?.is_from_qr),
);

const iconComponent = computed(() => {
  if (props.request?.is_from_qr === true) {
    return 'icon-qr';
  }
  if (props.request?.organization && props.request?.client?.is_temp && !props.request?.is_from_qr) {
    return 'icon-button-cursor';
  }
  return null;
});

const tooltipText = computed(() => {
  if (props.request?.is_from_qr === true) {
    return 'Přes QR kód';
  }
  if (props.request?.organization && props.request?.client?.is_temp && !props.request?.is_from_qr) {
    return 'Přes tlačítko organizace';
  }
  return '';
});
</script>

<style setup>
@reference "assets/css/tailwind.css";

.OperatorRequestQRButtonBadge {
  @apply text-muted w-4 h-auto flex items-center;
}
</style>
